export { useToastBodyBase_unstable as useToastBody } from '@fluentui/react-toast';
